import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const WindowsIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path
        fillRule="evenodd"
        d="M6.917 1.662 1.6 2.419V13.53l5.317.74V8.32l-5.314-.037v-.612l5.314-.04v-5.97Zm.742-.106v6.071l7.44-.055V.497L7.66 1.556Zm7.44 6.822-7.44-.052v6.047l7.44 1.034V8.378Z"
      />
    </CustomIcon>
  )
}
